import React, { Component } from 'react'
import TextWithFieldname from '../texts/TextWithFieldname';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TableAmortization extends Component {

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }
	render() { 
		return (
			<TextWithFieldname fieldname={this.props.fieldname} developperView={this.props.developperView} complexChild={true}>
				{!this.props.developperView && this.props.title && <h5>{this.props.title}</h5>}
				{this.props.developperView && <h6>{this.props.fieldname}</h6>}
				<div className="row shadow rounded p-0 m-1 table-responsive">
					<table className="table table-light table-striped">
						<thead>
							<tr className='table-primary'>
								<th className='text-center'>{this.props.developperView ? 'paymentNumber' : this.getMessage('amortization.paymentNumber')}</th>
								<th className='text-center'>{this.props.developperView ? 'amount' : this.getMessage('amortization.amount')}</th>
								<th className='text-center'>{this.props.developperView ? 'interestDueAmount' : this.getMessage('amortization.interestDueAmount')}</th>
								<th className='text-center'>{this.props.developperView ? 'capital' : this.getMessage('amortization.capital')}</th>
								<th className='text-center'>{this.props.developperView ? 'outstandingPrincipal' : this.getMessage('amortization.outstandingPrincipal')}</th>
								<th className='text-center'>{this.props.developperView ? 'optionBuyCoef' : this.getMessage('amortization.optionBuyCoef')}</th>
							</tr>
						</thead>
						<tbody>
							{this.props.amortizationSchedule.map((line, index) => (
								<tr key={index}>
									<td className='text-center'>{line.paymentNumber}</td>
									<td className='text-center'>{line.amount}</td>
									<td className='text-center'>{line.interestDueAmount}</td>
									<td className='text-center'>{line.capital}</td>
									<td className='text-center'>{line.outstandingPrincipal}</td>
									<td className='text-center'>{line.optionBuyCoef}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</TextWithFieldname>
		)
	}
}

export default (TableAmortization)


